import { Box, Text, useThemeUI } from "theme-ui";

import { Select } from "components";
import * as styles from "./DropDown.styles";

function getMinWidth(str = "") {
  return Math.ceil(str.length * 7.8) + 100 + "px";
}

export default function DropDown({
  label = "",
  options = [],
  value: selectedValue = "",
  placeholder = "",
  hint,
  onChange,
  size,
  width,
}) {
  const {
    theme: { isMobile },
  } = useThemeUI();

  const handleChange = ({ target: { value } }) => {
    // this is to handle values which maybe Integers
    onChange(
      options.find((option) => option.value.toString() === value)?.value ||
        value
    );
  };

  const minWidth = width || getMinWidth(placeholder);

  return (
    <Box sx={styles.dropDown}>
      <Box sx={styles.selectContainer({ minWidth })}>
        <Select
          label={label}
          variant="round"
          size={size ? size : isMobile ? "medium" : "large"}
          value={selectedValue}
          onChange={handleChange}
          sx={{
            minWidth,
          }}
        >
          {(placeholder.length > 0 ||
            !options.find(({ value }) => value === selectedValue)) && (
            <option key="__blank" value="" disabled={selectedValue}>
              {placeholder}
            </option>
          )}

          {options.map((option) => (
            <option key={option.value} value={option.value.toString()}>
              {option.label}
            </option>
          ))}
        </Select>
      </Box>

      {hint && (
        <Text
          variant={isMobile ? "h5Light" : "h4Light"}
          sx={{ textTransform: "initial" }}
        >
          {hint}
        </Text>
      )}
    </Box>
  );
}
